import React from 'react';
import PropTypes from 'prop-types';
import {DragSource} from 'react-dnd';


const Types = {
    ITEM: 'item'
};

const getDataFromNode = function (node) {
    const nodeDict = ['title', 'id', 'src', 'x', 'y', 'sprite_image'].reduce(
        (data, key) => {
            return {...data, [key]: node.attr[key]};
        }, {}
    );
    return nodeDict;
};

const boxSource = {
    beginDrag(props) {
        return props;
    },
    endDrag(props, monitor, component) {
        const didDrop = monitor.didDrop();
        if (!didDrop) {
            component.props.onDropOut(monitor.getItem(), props);
        }
    }
};

export class DdTargetOverlay extends React.Component {

    constructor(props) {
        super(props);
        const graphicState = props.selected ? 'selected' : '';
        // spriteImage conditional below is the way React simplified ternary operator to return true/false
        const spriteImage = !!props.node.attr['sprite_image'];
        this.state = {
            ...getDataFromNode(props.node),
            isDropped: props.isDropped,
            height: 0,
            graphicState,
            spriteImage,
        };
    }

    onImgLoad({target: img}) {
        // we use this method to set the height in this.state in the render method so we can apply
        // it ti sprite images in the div
        const {sprite_image} = this.state;
        if (sprite_image) {
            // source image is a sprite image (a single image containing 5 elements).
            this.setState({height: parseInt(img.offsetHeight) / 5});
        } else {
            // source image contains a single element
            this.setState({height: parseInt(img.offsetHeight)});
        }
    }

    onButtonMouseOver() {
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: 'hover'
            });
        }
    }

    onButtonMouseOut() {
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: ''
            });
        }
    }

    backgroundPosition() {
        const {graphicState, height,} = this.state;
        // On April 8th according to PITSCO, ALL sprite images, for ALL node types have the following index
        // properties: 1 -base, 2 - base, 3 - active, 4 - hover, 5 - disabled => array equivalent [0,1,2,3,4]
        // IF the sprite images appear in an incorrect order, forward ticket back to Pitsco and notify them that
        // sprite image order is incorrect, and send them index order which would replicate FRE functionality
        // DO NOT use Transformers!
        if (graphicState === 'selected') {
            // graphicState selected corresponds to 3 - Active state
            return `0 -${parseInt(height) * 2}px`;
        } else if (graphicState === 'hover') {
            // graphicState hover corresponds to 4 - hover (mouseOver) state
            return `0 -${parseInt(height) * 3}px`;
        } else if (graphicState === 'disabled') {
            // graphicState disabled corresponds to 5 - Disabled state
            return `0 -${parseInt(height) * 4}px`;
        } else {
            // Selected is null; ->
            // BASE state corresponds to 1 - base and 2 - base
            return '0 0';
        }
    }

    render() {
        const {moduleURL = '', connectDragSource} = this.props;
        let {isDropped = true, src, spriteImage} = this.state;

        const divStyle = {
            display: isDropped ? 'block' : 'none',
            background: `url(${moduleURL}/media/${src}) no-repeat`,
        };

        if(spriteImage){
            divStyle.backgroundPosition =  this.backgroundPosition();
            divStyle.height = this.state.height;
        }

        return connectDragSource(
            <div className="node dd-node dd-target-overlay-div" style={divStyle} onMouseOut={this.onButtonMouseOut.bind(this)} onMouseOver={this.onButtonMouseOver.bind(this)}>
                <img onLoad={this.onImgLoad.bind(this)} src={`${moduleURL}/media/${src}`} className={'visibility-hidden'}/>
            </div>
        );
    }
}

DdTargetOverlay.propTypes = {
    connectDragSource: PropTypes.func.isRequired
};

export default DragSource(Types.ITEM, boxSource, connect => ({
    connectDragSource: connect.dragSource()
}))(DdTargetOverlay);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/dd-target-overlay.js